export type ValidationResult = string | false | undefined
type ValidationSchema<T> = {
  [key in keyof T]?: ValidationResult[]
}
export type ValidationErrors<T> = {
  [key in keyof T]?: string
}

export function validate(check: boolean, errorMessage: string): ValidationResult {
  if (check) {
    return undefined
  } else {
    return errorMessage
  }
}

export function validateAll<T>(items: T[], validator: (T) => ValidationErrors<T>, errorMessage: string): ValidationResult {
  for (let item of items) {
    let result = validator(item)
    if (!isEmptyObject(result)) return errorMessage
  }
  return undefined
}

export function reduceErrors<T>(schema: ValidationSchema<T>): ValidationErrors<T> {
  let errors: ValidationErrors<T> = {}

  for (let field in schema) {
    for (let validation in schema[field]) {
      let result = schema[field][validation]
      if (result) {
        errors[field] = result
        break
      }
    }
  }

  return errors
}

export function isDefined(value: any): boolean {
  return value !== undefined
}

export function isNonEmptyString(value: string) {
  return value.length > 0
}

export function isEmptyObject(value: object) {
  for (var key in value) {
    if (value.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}

export function isPositiveOrZero(maybeNumber: number | undefined) {
  return maybeNumber !== undefined && !isNaN(maybeNumber) && maybeNumber >= 0
}
